import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { scrollToTop } from "../../Global/Scroll";
import { errorMessages } from "../../../Constants/Errors";
import { callAPI, useStore, usePage, useUser, isJson } from "../../../Utils/utils";
import { product_page_labels } from "../../../Constants/Labels";
import { product_page_message, alert_message_type } from "../../../Constants/Messages";
import { item_required_error_message } from "../../../Constants/Messages";
import ImagesPreview from '../../../Components/ImagesPreview/ImagesPreview';
import ImageSelector from "../../ImageSelector/ImageSelector";
import ErrorMessage from "../../Global/ErrorMessage"
import Alert from "../../Alert/Alert";
import TextEditor from "../../Global/TextEditor/TextEditor"
import Message from "../../Message/Message";
import './AddProduct.css';
import { Orientations } from "../../../Constants/constants"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function AddProduct() {

    const navigate = useNavigate();
    const { store, setStore } = useStore();
    const { page, setPage } = usePage();
    const { user, setUser } = useUser();
    const [mode, setMode] = useState('list');
    const [alert, setAlert] = useState();
    const [errors, setErrors] = useState();
    const [config, setConfig] = useState();
    const [payLoad, setPayLoad] = useState();
    const [loading, setLoading] = useState(false);
    const [lineItems, setLineItems] = useState([]);
    const [formValues, setformValues] = useState("");
    const [categories, setCategories] = useState();
    const [metaImage, setMetaImage] = useState(null);
    const [storeName, setStoreName] = useState([]);
    const [productSluge, setProductSluge] = useState("")
    const [selectedImages, setSelectedImages] = useState();
    const [addedImages, setAddedImages] = useState([]);
    const [removedImages, setRemovedImages] = useState([]);
    const [description, setDescription] = useState({})
    const [featuredImage, setFeaturedImage] = useState();
    const [content_for_printing, setContentForPrint] = useState({ page_3: "" })
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [searchCategoryName, setSearchCategoryName] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [orientation, setOrientation] = useState(Orientations['portrait'])
    // const [page_content, setPageContent] = useState("This holiday season \n [name_as_it_appears_on_card] \n made a generous donation in your honor to God's love we deliver \n with best wishes for peace, health and hope in the new year \n [personal_message]")
    var storeId = store?.id

    const onChangeField = (event) => {
        console.log("event", event);
        const { name, value, checked } = event.target;

        if (name == 'meta_title' || name == "name") {
            // If the field is 'meta_title', remove or replace special characters
            const sanitizedValue = value.replace(/[^a-zA-Z0-9\s|—–:…?!"()[\]+&_/.-]/g, '')?.replace(/\//g, '-');
            setformValues({ ...formValues, [name]: sanitizedValue });
        }
        // else if(name == 'is_email_card'){
        //     setformValues({ ...formValues, [name]: checked });
        // }
        else {
            // For other fields, simply update the state
            setformValues({ ...formValues, [name]: value });
        }
        setErrors([]);
        setShowErrorMessage(false);
    };

    useEffect(() => {
        if (formValues['name']) {
            setProductSluge(formValues['name']?.toLowerCase()
                .replace(/\s+/g, '-') // Replace consecutive spaces with a single hyphen
                .replace(/-+/g, '-') // Replace consecutive hyphens with a single hyphen
                .replace(/[^a-zA-Z0-9-]/g, '') // Remove any characters other than alphanumeric and hyphens
                ?.trim()// Remove leading and trailing spaces
            )
        }
        else {
            setProductSluge("")
        }
    }, [formValues['name']])

    useEffect(() => {
        if (storeName?.length == 0 || storeName == undefined) {
            setStoreName(() => [store?.name])
        }
        else {
            setStoreName((existingStoreId) => [...existingStoreId, store?.name])
        }

    }, [store?.id])

    useEffect(() => {
        if (storeName[1] != undefined) {
            if (storeName[0] != storeName[1]) {
                navigate("/admin")
                setStoreName([])
            }
        }
    }, [storeName])

    // get data from database on page onload
    useEffect(() => {

        if (storeId) {

            var inital_pay_load = {
                "store_id": storeId,
                "status": "all"
            }

            var pay_load = payLoad || inital_pay_load
            pay_load.page_size = 100
            pay_load.current_page = 1
            // console.log("pay_load", pay_load)

            callAPI('/admin/category/by-store',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'token': user?.auth_token
                    },
                    body: JSON.stringify(pay_load)
                }, navigate, setLoading)

                .then(data => {
                    // console.log("api response " + JSON.stringify(data))
                    if (data?.success == true) {
                        setCategories(data?.records)
                    } else {
                        // console.log('Error occurred. Please try again.')
                    }
                })
        }
    }, [storeId, payLoad])

    // set the loading status into context whenever loading value changes  
    useEffect(() => {
        setPage({ isLoading: loading })
    }, [loading])

    // check the required fields and Posting the data to database
    const createProduct = () => {
        // This enables smooth scrolling
        scrollToTop()

        if (formValues['short_description'] && formValues['short_description']?.length > 2000) {
            setErrors([{ field_name: 'short_description', message: 'Short description cannot exceed 2000 characters' }]);
            setShowErrorMessage(true);
            setLoading(false);
            setAlert({ text: item_required_error_message, type: alert_message_type?.error });
            return;
        }

        const categories_payload = lineItems?.map(category => category?.category_id)?.filter(id => id !== undefined && id !== null) || [];
        const primaryCategory = lineItems?.find(cat => cat.is_primary) || lineItems?.[0];
        const primaryCategoryId = primaryCategory ? primaryCategory.category_id : null;

        // Convert and filter null values from addedImages array
        var added_images = addedImages?.map(item => parseInt(item)).filter(item => !isNaN(item));

        // Convert and filter null values from removedImages array
        var removed_images = removedImages?.map(item => parseInt(item)).filter(item => !isNaN(item));

        // Filter out image IDs that are present in both added_images and removed_images arrays
        // var added_images_ids = added_images?.filter(Image => !removed_images?.includes(Image));

        const added_images_ids = added_images?.filter(item => {
            const indexInRemoved = removed_images?.indexOf(item);
            if (indexInRemoved !== -1) {
                removed_images?.splice(indexInRemoved, 1);
                return false;
            }
            return true;
        });

        // Filter out invalid values from added_images_ids array
        var added_product_images = added_images_ids?.filter(item => !Array.isArray(item) || item?.length > 0);

        const added_gallery_images_ids = [...new Set(added_product_images)];

        // If there are no valid added product images, set added_product_images to an empty array
        if (!added_gallery_images_ids) {
            added_gallery_images_ids = [];
        }

        // console.log("added_product_images",added_product_images)
        // console.log("removed_product_images",removed_product_images)

        var pay_load = {
            "name": formValues['name']?.trim() || "",
            "sku": formValues['sku'] || "",
            "price": formValues['price'] || "",
            // "is_email_card": formValues['is_email_card'] || false,
            // "email_price": formValues['is_email_card'] ? formValues['email_price'] : null,
            "product_type": formValues["product_type"] || "",
            "status": formValues?.status || 'inactive',
            "store_id": storeId,
            "product_descriptions": {
                "short_description": formValues['short_description'] || "",
                "description": description && Object.keys(description)?.length ? description : "",
                "meta_title": formValues["meta_title"] || "",
                "meta_description": formValues["meta_description"] || "",
                "meta_image": metaImage?.image_id || null,
            },
            "categories": categories_payload,
            "primary_category_id": primaryCategoryId,
            "images": { "images": added_gallery_images_ids },
            "featured_image": featuredImage?.image_id || null,
            "stock": formValues['stock'] || null,
            "slug": productSluge || "",
            "card_orientation": orientation
        }
        if (formValues.product_type == "PERSONALIZED-CRD" || formValues.product_type == "E-CRD" || formValues.product_type == "CSTM-CRD-PRINT" || formValues.product_type == "CSTM-CRD-EMAIL") {
            pay_load.content_for_printing = {}
            if (formValues.product_type != "CSTM-CRD-PRINT" && formValues.product_type != "CSTM-CRD-EMAIL") {
                pay_load.content_for_printing.page_1 = content_for_printing?.page_1?.image_id
            }
            if (formValues.product_type?.toUpperCase() === "CSTM-CRD-PRINT") {
                pay_load.content_for_printing.page_2_portrait = content_for_printing?.page_2_portrait?.image_id
                pay_load.content_for_printing.page_2_landscape = content_for_printing?.page_2_landscape?.image_id
                pay_load.content_for_printing.page_4_portrait = content_for_printing?.page_4_portrait?.image_id
                pay_load.content_for_printing.page_4_landscape = content_for_printing?.page_4_landscape?.image_id
            } else if (formValues.product_type?.toUpperCase() === "PERSONALIZED-CRD") {
                pay_load.content_for_printing.page_2_image = content_for_printing?.page_2_image?.image_id
                pay_load.content_for_printing.page_4 = content_for_printing.page_4?.image_id
            } else {
                pay_load.content_for_printing.page_2 = content_for_printing.page_2
                pay_load.content_for_printing.page_4 = content_for_printing.page_4?.image_id
            }
            pay_load.content_for_printing.page_3 = content_for_printing.page_3
        }

        setLoading(true)
        // console.log('payload', JSON.stringify(pay_load))
        callAPI('/admin/products/create',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': user?.auth_token
                },
                body: JSON.stringify(pay_load)
            }, navigate, setLoading)
            .then(data => {
                // console.log("api response " + JSON.stringify(data))
                if (data?.success == true) {
                    var id = data?.product_id
                    navigate(`/admin/product/edit/${id}`)
                    localStorage.setItem('Message', product_page_message?.create_message)
                    setLoading(false)
                } else {
                    setErrors(data?.errors)
                    setShowErrorMessage(true)
                    setLoading(false)
                    setAlert({ text: item_required_error_message, type: alert_message_type?.error })
                    // console.log("errors", data?.errors)
                }
            }
            )
    }
    // console.log("json", content_for_printing);

    //get the product name during on change of the input value 
    const onSearchCategoryName = (event) => {
        setSearchCategoryName(event.target.value)
        setMode('open')

        var pay_load = {
            "store_id": storeId,
            "status": "all",
        }

        if (event.target.value) {
            pay_load.filters = {
                "conditions": [
                    { "field": "name", "operator": "like", "value": event.target.value, "dataType": "string" }
                ]
            }
        }

        setPayLoad(pay_load)
    }

    const onClickListCatrgory = () => {
        setMode('open')
        var pay_load = {
            "store_id": storeId,
            "status": "all",
        }
        setPayLoad(pay_load)
    }


    const onChangeFields = (event, category) => {
        // console.log("category",category)
        if (selectedCategories?.length == 0 && !selectedCategories?.some((selectedCategory) => selectedCategory?.category_id == category?.category_id)) {
            setSelectedCategories([category]);
        }
        else if (selectedCategories?.length > 0 && !selectedCategories?.some((selectedCategory) => selectedCategory?.category_id == category?.category_id)) {
            setSelectedCategories([...selectedCategories, category]);
        }
        else {
            // Remove the unselected product from the selectedCategories list.
            setSelectedCategories(selectedCategories?.filter((selectedCategory) => selectedCategory?.category_id != category?.category_id));
        }
    }

    //Add the selected category to line items
    const onClickAddLineItems = () => {
        const currentPrimary = lineItems.find(item => item?.is_primary)?.category_id;
        var newLineItems = [] //array of objects
        //display the items based on the selected category
        selectedCategories?.forEach((selectedCategory, index) => {
            let isPrimary = false;
            if (currentPrimary) {
                isPrimary = selectedCategory?.category_id === currentPrimary;
            } else if (index === 0) {
                isPrimary = true;
            }
            newLineItems.push({
                category_id: selectedCategory?.category_id,
                store_id: store?.id,
                name: selectedCategory?.name,
                price_per_item: selectedCategory?.price,
                quantity: 1,
                is_primary: isPrimary
            })
        })

        if (newLineItems.length > 0 && !newLineItems.some(item => item.is_primary)) {
            newLineItems[0].is_primary = true;
        }

        // console.log("newline items during add line items - ", newLineItems)
        setLineItems(newLineItems)
        setMode('close')
        setSearchCategoryName("")

    }

    const handleSelectPrimaryCategory = (categoryId) => {
        setLineItems(prevItems =>
            prevItems.map(item => ({
                ...item,
                is_primary: item.category_id === categoryId
            }))
        );
    }

    //remove the line items
    const onClickRemoveProduct = (productIndex) => {
        //remove the line item from the line items
        const updatedLineItems = lineItems.filter((v, i) => i != productIndex);
        if (updatedLineItems.length > 0 && !updatedLineItems.some(item => item.is_primary)) {
            updatedLineItems[0].is_primary = true;
        }
        setLineItems(updatedLineItems)
        //remove the line item from the selected products list
        setSelectedCategories(updatedLineItems)
    }

    //close the dropdown when click to cancel button
    const onClickCloseDropdown = () => {
        setMode('close')
        setSearchCategoryName("")
        //clear the selected products when click to cancel button
        if (lineItems?.lenght == 0) {
            setSelectedCategories([])
        }
        else if (lineItems?.lenght != 0) {
            setSelectedCategories(lineItems)
        }

    }

    const onChageSlug = (event) => {
        const value = event.target.value;
        const slug = value
            .toLowerCase()
            .replace(/\s+/g, '-') // Replace consecutive spaces with a single hyphen
            .replace(/-+/g, '-') // Replace consecutive hyphens with a single hyphen
            .replace(/[^a-zA-Z0-9-]/g, '') // Remove any characters other than alphanumeric and hyphens
            ?.trim(); // Remove leading and trailing spaces

        setProductSluge(slug);
    }

    const onOpen = (config) => {
        setConfig(config)
    }

    const onClose = (addedSelectedImages, removedSelectedImages) => {
        setConfig(false)
        if (config.acceptMultipleFiles == true && addedImages.length == 0) {
            setAddedImages(addedSelectedImages)
        }
        if (config.acceptMultipleFiles == true && addedImages?.length != 0) {
            setAddedImages((previousImages) => [
                ...previousImages,
                ...addedSelectedImages
                    .map(item => Number(item))
                    .filter(item => typeof item === 'number')
            ]);

        }
        if (removedImages?.length == 0 && removedSelectedImages) {
            setRemovedImages(removedSelectedImages)
        }
        else if (removedImages?.length != 0 && removedImages.length != undefined && removedSelectedImages) {
            setRemovedImages((removedPreviousImages) => [...removedPreviousImages, removedSelectedImages])
        }
        else if (removedSelectedImages) {
            setRemovedImages(removedSelectedImages)
        }
    }

    const onSelectImages = (images) => {
        if (config.acceptMultipleFiles == false) {
            if (config.printImage) {
                setContentForPrint({ ...content_for_printing, [config.printImage]: images })
            }
            else if (config.featuredImage) {
                setFeaturedImage(images)
            } else {
                setMetaImage(images)
            }
        }
        else if (config.acceptMultipleFiles == true) {
            setSelectedImages(images)
        }

    }

    const onRemovePreviewImageIds = (images) => {
        if (removedImages?.length == 0 && removedImages?.length != undefined) {
            setRemovedImages([images])
        }
        else if (removedImages?.length != 0 && removedImages?.length != undefined) {
            setRemovedImages((PreviousImages) => [...PreviousImages, images])
        }

    }

    const onRemoveFeaturedImagIds = () => {
        setFeaturedImage(null)
    }

    const onRemoveMetaImageIds = () => {
        setMetaImage(null)
    }

    const numberInputOnWheelPreventChange = (e) => {
        // Prevent the input value change
        e.target.blur()

        // Prevent the page/container scrolling
        e.stopPropagation()

        // Refocus immediately, on the next tick (after the current function is done)
        setTimeout(() => {
            e.target.focus()
        }, 0)
    }

    const handleDragEndImages = (images) => {
        if (images) {
            const imageIds = images.map(item => parseInt(item.image_id));
            setAddedImages(imageIds);
        }
    }

    const status = Object.keys(product_page_labels?.product_add_and_edit_page_status)?.map((name) => {
        const value = product_page_labels?.product_add_and_edit_page_status[name];
        return `${name},${value}`;
    });

    const productType = store?.sub_domain == 'glwd' ? (Object.keys(product_page_labels?.glwd_product_type)?.map((name) => {
        const value = product_page_labels?.glwd_product_type[name];
        return `${name},${value}`;
    })) : (Object.keys(product_page_labels?.product_type)?.map((name) => {
        const value = product_page_labels?.product_type[name];
        return `${name},${value}`;
    }));

    // console.log("addedImages",addedImages)

    const onChangeTextEditorValue = (productDescriptions) => {
        console.log("productDescriptions", productDescriptions);
        setDescription(productDescriptions)
    }

    const onCloseDropdown = () => {
        setMode("close")
        setSearchCategoryName("")
    }

    // console.log("form",formValues);

    return (
        <React.Fragment>

            {alert?.text ?
                <div className="text-center">
                    <Alert text={alert.text} type={alert.type} setAlert={setAlert} />
                </div>
                : ''}

            <button className="btn btn-primary saveButton mb-4" onClick={() => createProduct()}>{product_page_labels?.product_add_page_labels?.btn_label}</button>
            <div className="row">
                <div className="col-lg-8">
                    <div className="card card-default">
                        <div className="card-header card-header-border-bottom">
                            <h2>{product_page_labels?.product_add_page_labels?.title}</h2>
                        </div>
                        <div className="card-body">
                            <label className="form-label mandatory_field">{product_page_labels?.product_add_and_edit_page_labels?.name}</label>
                            {/* <input type="text" className="form-control " maxLength="100" name='name' onChange={onChangeField} value={formValues['name'] || ""} /> */}
                            <textarea type="text" className="form-control" maxLength="105" rows={3} name='name' onChange={onChangeField} value={formValues['name'] || ""} />
                            <div className="errorMessage">
                                <Message text={errorMessages[ErrorMessage({ fieldName: 'name', errors })] || ErrorMessage({ fieldName: 'name', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                            </div>
                            <label className="form-label">{product_page_labels?.product_add_and_edit_page_labels?.short_description}</label>
                            <p style={{ fontSize: "12px", color: (formValues['short_description']?.length > 2000) ? "red" : "inherit" }}>Characters remaining: {2000 - (formValues['short_description'] || '')?.length}</p>
                            <textarea type="text" className="form-control" rows="2" cols="25" name='short_description' onChange={onChangeField} value={formValues['short_description'] || ""} />
                            <div className="errorMessage">
                                <Message text={formValues['short_description']?.length > 2000 ? (errorMessages['short_description_max_limit'] || "Short description cannot exceed 2000 characters") : (errorMessages[ErrorMessage({ fieldName: 'short_description', errors })] || ErrorMessage({ fieldName: 'short_description', errors }))} type={"errorMsg"} showMessage={formValues['short_description']?.length > 2000 || showErrorMessage} />
                            </div>
                            <label className="form-label">{product_page_labels?.product_add_and_edit_page_labels?.description}</label>
                            <div className="describtionEditor">
                                {/* <TextEditor onChangeTextEditorValue={onChangeTextEditorValue} /> */}
                                <ReactQuill theme="snow" value={description} onChange={onChangeTextEditorValue} />
                            </div>
                            {/* <textarea type="text" className="form-control" rows="4" cols="50" name='description' onChange={onChangeField} value={formValues['description'] || ""} /> */}
                            <div>
                                <label className="form-label mandatory_field">{product_page_labels?.product_add_and_edit_page_labels?.slug}</label>
                                <input type="text" className="form-control " name="slug" value={productSluge} maxLength="100" onChange={onChageSlug} />
                                <div className="errorMessage">
                                    <Message text={errorMessages[ErrorMessage({ fieldName: 'slug', errors })] || ErrorMessage({ fieldName: 'slug', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-lg-4">
                                    <label className="form-label mandatory_field">{product_page_labels?.product_add_and_edit_page_labels?.price}</label>
                                    <input type="number" className="form-control " name='price' placeholder='0.00' onChange={onChangeField} value={formValues['price'] || ""} onWheel={numberInputOnWheelPreventChange} onKeyPress={(e) => {
                                        const disallowedCharacters = ["-", "+"];
                                        const inputValue = e.target.value;

                                        if (disallowedCharacters.includes(e.key)) {
                                            e.preventDefault();
                                        }
                                        if (inputValue.includes(".") && inputValue.split(".")[1].length >= 2) {
                                            e.preventDefault();
                                        }
                                    }}

                                        onKeyDown={(e) => {
                                            // Prevent up and down arrow key actions
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <div className="errorMessage">
                                        <Message text={errorMessages[ErrorMessage({ fieldName: 'price', errors })] || ErrorMessage({ fieldName: 'price', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                    </div>
                                </div>
                                {/* <div className="col-8 row">
                                    <div className="col-lg-6">
                                        <label className="form-label ">Email Card</label>

                                        <div className="d-flex justify-align-center">
                                            <input type="checkbox" className="mb-0" name="is_email_card" value={formValues["is_email_card"]} onChange={onChangeField} />
                                        </div>
                                    </div>
                                    {formValues.is_email_card &&
                                        <div className="col-lg-6">
                                            <label className="form-label mandatory_field">Email Card Price</label>
                                            <input type="number" className="form-control " name='email_price' placeholder='0.00' onChange={onChangeField} value={formValues['email_price'] || ""} onWheel={numberInputOnWheelPreventChange} onKeyPress={(e) => {
                                                const disallowedCharacters = ["-", "+"];
                                                const inputValue = e.target.value;

                                                if (disallowedCharacters.includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                                if (inputValue.includes(".") && inputValue.split(".")[1].length >= 2) {
                                                    e.preventDefault();
                                                }
                                            }}

                                                onKeyDown={(e) => {
                                                    // Prevent up and down arrow key actions
                                                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <div className="errorMessage">
                                                <Message text={errorMessages[ErrorMessage({ fieldName: 'email_price', errors })] || ErrorMessage({ fieldName: 'price', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                            </div>
                                        </div>}
                                </div> */}
                                <div className="col-lg-4">
                                    <label className="form-label">{product_page_labels?.product_add_and_edit_page_labels?.stock}</label>
                                    <input type="number" className="form-control" name='stock' placeholder='Stock' onChange={onChangeField} value={formValues['stock'] || ""} onWheel={numberInputOnWheelPreventChange} onKeyPress={(e) => {
                                        const disallowedCharacters = ["-", "+"];
                                        const inputValue = e.target.value;
                                        if (disallowedCharacters.includes(e.key)) {
                                            e.preventDefault();
                                        }
                                        if (inputValue.includes(".") && inputValue.split(".")[1].length >= 2) {
                                            e.preventDefault();
                                        }
                                    }}

                                        onKeyDown={(e) => {
                                            // Prevent up and down arrow key actions
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <div className="errorMessage">
                                        <Message text={errorMessages[ErrorMessage({ fieldName: 'stock', errors })] || ErrorMessage({ fieldName: 'stock', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label mandatory_field">{product_page_labels?.product_add_and_edit_page_labels?.sku}</label>
                                    <input type="text" className="form-control  slug-title" name='sku' placeholder='SKU' maxLength="30" onChange={onChangeField} value={formValues['sku'] || ""} />
                                    <div className="errorMessage">
                                        <Message text={errorMessages[ErrorMessage({ fieldName: 'sku', errors })] || ErrorMessage({ fieldName: 'sku', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="mb-3 mt-1 col-lg-4">
                                    <label className="form-label mandatory_field">{product_page_labels?.product_add_and_edit_page_labels?.product_type}</label>
                                    <select className="form-control" name='product_type' onChange={onChangeField} value={formValues['product_type'] || ""}>
                                        <option hidden>Select</option>
                                        {productType &&
                                            productType?.map((optionString) => {
                                                const [name, value] = optionString.split(',');
                                                return <option value={name} key={name}>{value}</option>;
                                            })
                                        }
                                    </select>
                                    <div className="errorMessage mt-3">
                                        <Message text={errorMessages[ErrorMessage({ fieldName: 'product_type', errors })] || ErrorMessage({ fieldName: 'product_type', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                    </div>
                                </div>
                                <div className="mt-1 col-lg-7">
                                    <label className="form-label mandatory_field">Orientation</label>
                                    <div className="d-flex justify-items-center">
                                        <div className="d-flex">
                                            <input type="radio" checked={orientation == Orientations["portrait"]} className="m-0" id="portrait" onChange={() => setOrientation(Orientations["portrait"])} />
                                            <p className=" px-3" style={{ paddingTop: 7 }}>Portrait</p>
                                        </div>
                                        <div className="d-flex ml-5">
                                            <input type="radio" checked={orientation == Orientations["landscape"]} className="m-0" id="landscape" onChange={() => setOrientation(Orientations["landscape"])} />
                                            <p className=" px-3" style={{ paddingTop: 7 }}>Landscape</p>
                                        </div>
                                        <div className="d-flex ml-5">
                                            <input type="radio" checked={orientation == Orientations["dual"]} className="m-0" id="dual" onChange={() => setOrientation(Orientations["dual"])} />
                                            <p className=" px-3" style={{ paddingTop: 7 }}>Dual</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-5 d-flex col-lg-12 justify-content-between ">
                        <div style={{ width: "45%" }}>
                            <div className="card card-default">
                                <div className="card-header card-header-border-bottom">
                                    <h2>{product_page_labels?.product_add_and_edit_page_labels?.featured_image}</h2>
                                </div>
                                <div className="card-body p-3">
                                    <ImagesPreview acceptMultipleFiles={false} featuredImage={true} userProfile={false} onOpen={onOpen} selectedImageInfo={featuredImage} onRemoveImageIds={onRemoveFeaturedImagIds} deleteDisable={true} />
                                </div>
                            </div>
                        </div>
                        <div style={{ width: "53%" }}>
                            <ImagesPreview acceptMultipleFiles={true} onOpen={onOpen} selectedImageInfo={selectedImages} onRemoveImageIds={onRemovePreviewImageIds} deleteDisable={true} handleDragEndImages={handleDragEndImages} />
                        </div>
                    </div>
                    {(formValues['product_type'] == "PERSONALIZED-CRD" || formValues['product_type'] == "E-CRD" || formValues['product_type'] == "CSTM-CRD-PRINT" || formValues['product_type'] == "CSTM-CRD-EMAIL") &&
                        <div className="card card-default mt-5">
                            <div className="card-header card-header-border-bottom">
                                <h2>{(formValues['product_type'] == "PERSONALIZED-CRD" || formValues['product_type'] == "CSTM-CRD-PRINT") ? product_page_labels?.product_add_and_edit_page_labels?.content_for_printing : formValues['product_type'] == "CSTM-CRD-PRINT" ? "Content for Printing" : product_page_labels?.product_add_and_edit_page_labels?.content_for_email}</h2>
                            </div>
                            <div className="card-body">
                                <div className="d-flex flex-wrap">
                                    {(formValues['product_type'] == "PERSONALIZED-CRD" || formValues['product_type'] == "E-CRD") && <div className="w-50 p-2 mb-2" >
                                        <label>{formValues['product_type'] == "PERSONALIZED-CRD" ? 'Page 1' : 'Front'} (Image)</label>
                                        <div >
                                            <ImagesPreview acceptMultipleFiles={false} orientation={orientation} printImage={"page_1"} userProfile={false} onOpen={onOpen} selectedImageInfo={content_for_printing?.page_1} onRemoveImageIds={() => { setContentForPrint({ ...content_for_printing, front: null }) }} deleteDisable={true} />
                                        </div>
                                    </div>}
                                    {formValues['product_type'] == "CSTM-CRD-PRINT" ? (
                                        <>
                                            <div className="w-50 p-2 mb-2">
                                                <label>Page 2 Portrait (Image)</label>
                                                <div>
                                                    <ImagesPreview acceptMultipleFiles={false} orientation={Orientations["portrait"]} printImage={"page_2_portrait"} userProfile={false} onOpen={onOpen} selectedImageInfo={content_for_printing?.page_2_portrait} onRemoveImageIds={() => { setContentForPrint({ ...content_for_printing, page_2_portrait: null }) }} deleteDisable={true} />
                                                </div>
                                            </div>
                                            <div className="w-50 p-2 mb-2">
                                                <label>Page 2 Landscape (Image)</label>
                                                <div>
                                                    <ImagesPreview acceptMultipleFiles={false} orientation={Orientations["landscape"]} printImage={"page_2_landscape"} userProfile={false} onOpen={onOpen} selectedImageInfo={content_for_printing?.page_2_landscape} onRemoveImageIds={() => { setContentForPrint({ ...content_for_printing, page_2_landscape: null }) }} deleteDisable={true} />
                                                </div>
                                            </div>
                                        </>
                                    ) : formValues['product_type']?.toUpperCase() === "PERSONALIZED-CRD" ? (
                                        <div className="w-50 p-2 mb-2">
                                            <label>Page 2 (Image)</label>
                                            <div>
                                                <ImagesPreview acceptMultipleFiles={false} orientation={orientation} printImage={"page_2_image"} userProfile={false} onOpen={onOpen} selectedImageInfo={content_for_printing?.page_2_image} onRemoveImageIds={() => { setContentForPrint({ ...content_for_printing, page_2_image: null }) }} deleteDisable={true} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="w-50 p-2 page_2_portrait">
                                            <label>Attribution</label>
                                            {/* <TextEditor onChangeTextEditorValue={SetPage2Content} productDescription={content_for_printing?.page_2 || ""} /> */}
                                            <ReactQuill theme="snow" value={content_for_printing.page_2} onChange={(value) => setContentForPrint({ ...content_for_printing, ['page_2']: value })} />
                                            {/* <textarea type="text" className="form-control" rows={orientation == Orientations["portrait"] ? 11 : 6} value={content_for_printing['page_2']} style={{ padding: 15, borderRadius: 10 }} name="page_2" onChange={(e) => setContentForPrint({...content_for_printing,[e.target.name]:e.target.value})} /> */}
                                        </div>
                                    )}
                                    <div className="w-50 p-2">
                                        <label>{(formValues['product_type'] == "PERSONALIZED-CRD" || formValues['product_type'] == "CSTM-CRD-PRINT") ? 'Page 3' : 'Back'} (Copy)</label>
                                        <textarea type="text" className="form-control" rows={(orientation == Orientations["portrait"] || formValues['product_type'] == "CSTM-CRD-PRINT") ? 11 : 6} value={content_for_printing['page_3']} style={{ padding: 15, borderRadius: 10 }} name="page_3" onChange={(e) => setContentForPrint({ ...content_for_printing, [e.target.name]: e.target.value })} />
                                        {/* <Message type={"errorMsg"} text="insert valid json text" showMessage={!isJson(page_3_content)} /> */}
                                    </div>
                                    {formValues['product_type'] == "CSTM-CRD-PRINT" && <>
                                        <div className="w-50 p-2">
                                            <label>Page 4 Portrait (Image)</label>
                                            <ImagesPreview acceptMultipleFiles={false} orientation={Orientations["portrait"]} printImage={"page_4_portrait"} userProfile={false} onOpen={onOpen} selectedImageInfo={content_for_printing?.page_4_portrait} onRemoveImageIds={() => { setContentForPrint({ ...content_for_printing, page_4_portrait: null }) }} deleteDisable={true} />
                                        </div>
                                        <div className="w-50 p-2">
                                            <label>Page 4 Landscape (Image)</label>
                                            <ImagesPreview acceptMultipleFiles={false} orientation={Orientations["landscape"]} printImage={"page_4_landscape"} userProfile={false} onOpen={onOpen} selectedImageInfo={content_for_printing?.page_4_landscape} onRemoveImageIds={() => { setContentForPrint({ ...content_for_printing, page_4_landscape: null }) }} deleteDisable={true} />
                                        </div>
                                    </>}
                                    {(formValues['product_type'] != "E-CRD" && formValues['product_type'] != "CSTM-CRD-EMAIL" && formValues['product_type'] != "CSTM-CRD-PRINT") && <div className="w-50 p-2">
                                        <label>Page 4 (Image)</label>
                                        <ImagesPreview acceptMultipleFiles={false} orientation={orientation} printImage={"page_4"} userProfile={false} onOpen={onOpen} selectedImageInfo={content_for_printing?.page_4} onRemoveImageIds={() => { setContentForPrint({ ...content_for_printing, back: null }) }} deleteDisable={true} />
                                    </div>}
                                </div>
                            </div>
                        </div>
                    }
                    <div className="card card-default mt-5">
                        <div className="card-header card-header-border-bottom">
                            <h2>{product_page_labels?.product_add_and_edit_page_labels?.categories}</h2>
                        </div>
                        <div className="card-body">
                            <div className="productSearchWrapper">
                                <div className="search-form d-lg-inline-block searchWrapper">
                                    <div className="input-group">
                                        <input type="text" name="query" id="search-input" className="form-control searchInput" placeholder={`${product_page_labels?.product_add_and_edit_page_labels?.category_placeholder}`} value={searchCategoryName} onChange={onSearchCategoryName} onClick={onClickListCatrgory} />
                                    </div>
                                </div>
                                {mode == 'open' &&
                                    <div className={`${categories ? "categorieList" : "noCategorieList"}`} >
                                        <ul id="search-results">
                                            {categories?.map((list, index) => {
                                                var alreadySelectedItem = lineItems?.find((item) => item?.category_id == list?.category_id)
                                                const isProductInSelected = selectedCategories?.some((selectedCategory) => selectedCategory?.category_id == list?.category_id);
                                                return (
                                                    <li
                                                        key={index}
                                                        className={`${alreadySelectedItem || isProductInSelected ? "hasSelected seletedLineItem" : ""} productDropDown`}
                                                    >
                                                        <div
                                                            className={`${alreadySelectedItem || isProductInSelected ? "hasSelected seletedLineItem" : ""} w-100`}

                                                            onClick={() => onChangeFields(!alreadySelectedItem, list)}>
                                                            <input
                                                                type="checkbox"
                                                                id={list?.category_id}
                                                                name={list?.category_id}
                                                                value={list?.category_id}
                                                                checked={alreadySelectedItem || isProductInSelected}
                                                                onChange={() => { }}
                                                            />
                                                            <span className="checkBoxLabel">
                                                                {list?.name}
                                                            </span>
                                                        </div>

                                                    </li>
                                                )
                                            })}
                                            {categories == '' && <p className="text-center mt-3 mb-5">{product_page_message?.category_not_found}</p>}
                                        </ul>
                                        {categories != '' && categories?.lenght != 0 &&
                                            <div className="d-flex categorieListbutton mt-3">
                                                <button className="addButton" onClick={onClickAddLineItems}>{product_page_labels?.product_add_and_edit_page_labels?.category_btn_add}</button>
                                                <button className="cancelButton" onClick={onClickCloseDropdown}>{product_page_labels?.product_add_and_edit_page_labels?.category_btn_cancel}</button>
                                                <button className="ml-auto addButton" onClick={() => onCloseDropdown()}>{product_page_labels?.product_add_and_edit_page_labels?.category_btn_close}</button>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            {lineItems != null &&
                                <>
                                    {lineItems?.map((lineItem, index) => {
                                        // console.log("lineItem",lineItem)
                                        return (
                                            <div key={index} className="searchList">
                                                <span className="categoryName">{lineItem?.name}</span>
                                                <div className="primaryCategoryWrapper">
                                                    <label className={`primaryCategoryLabel ${lineItem?.is_primary ? "isPrimary" : ""}`}>
                                                        <input
                                                            type="checkbox"
                                                            name={`primary_category_${lineItem?.category_id}`}
                                                            className="primaryCategoryCheckbox"
                                                            checked={!!lineItem?.is_primary}
                                                            onChange={() => handleSelectPrimaryCategory(lineItem?.category_id)}
                                                        />
                                                        <span>Primary</span>
                                                    </label>
                                                    <span className="removeProduct" onClick={() => onClickRemoveProduct(index)} title="Remove">
                                                        <span className="mdi mdi-close"></span>
                                                    </span>
                                                </div>
                                            </div>
                                        )
                                    })}

                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="card card-default">
                        <div className="card-body">
                            <label className="form-label">{product_page_labels?.product_add_and_edit_page_labels?.status}</label>
                            <select className="form-control" name='status' onChange={onChangeField} value={formValues['status'] || ""}>
                                {status &&
                                    status?.map((optionString) => {
                                        const [name, value] = optionString.split(',');
                                        return <option value={name} key={name}>{value}</option>;
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="card card-default mt-5">
                        <div className="card-header card-header-border-bottom">
                            <h2>{product_page_labels?.product_add_and_edit_page_labels?.seo}</h2>
                        </div>
                        <div className="card-body">
                            <div className="ec-store-uploads">
                                <label className="form-label">{product_page_labels?.product_add_and_edit_page_labels?.meta_title}</label>
                                <input type="text" className="form-control " name='meta_title' maxLength="100" onChange={onChangeField} value={formValues['meta_title'] || ""} />
                                <label className="form-label">{product_page_labels?.product_add_and_edit_page_labels?.meta_description}</label>
                                <textarea type="text" className="form-control slug-title " rows="4" cols="50" name='meta_description' maxLength="500" onChange={onChangeField} value={formValues['meta_description'] || ""} />
                                <label className="form-label">{product_page_labels?.product_add_and_edit_page_labels?.meta_image}</label>
                                <ImagesPreview acceptMultipleFiles={false} featuredImage={false} userProfile={false} onOpen={onOpen} selectedImageInfo={metaImage} onRemoveImageIds={onRemoveMetaImageIds} deleteDisable={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ImageSelector Config={config} onClose={onClose} onSelectImageInfo={onSelectImages} />
            <div className="text-right">
                <button className="btn btn-primary" onClick={() => createProduct()}>{product_page_labels?.product_add_page_labels?.btn_label}</button>
            </div>
            <iframe src="blob:nodedata:80e747a0-47da-4b6c-b322-c31bb32f840a"></iframe>

        </React.Fragment >
    )
} 